import { FC, useState } from 'react';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import { IconButton, Typography } from '@mui/material';
import { Stack } from '@mui/system';

type CustomColumnProps = {
  value: string;
  onAddZoneClick?: () => void;
};

const CustomColumn: FC<CustomColumnProps> = ({ value, onAddZoneClick }) => {
  const [hoveredCell, setHoveredCell] = useState(false);

  const ICON_SIZE = 20;

  return (
    <Stack
      direction='row'
      spacing={2}
      alignItems='center'
      onMouseEnter={() => setHoveredCell(true)}
      onMouseLeave={() => setHoveredCell(false)}
    >
      <Typography variant='body2'>{value}</Typography>

      {value && (
        <Stack
          direction='row'
          gap={1}
          sx={{
            opacity: hoveredCell ? 1 : 0,
            transition: 'opacity 0.3s',
          }}
        >
          <IconButton size='small' onClick={onAddZoneClick}>
            <AddCircleIcon sx={{ width: ICON_SIZE, height: ICON_SIZE }} />
          </IconButton>
        </Stack>
      )}
    </Stack>
  );
};

export default CustomColumn;
